import _ from "lodash";
import { generate } from "randomstring";
import { postRequest, uploadEncodedFile } from "@network";
import { INSTANCE_URL, BASE_IMAGES_URL } from "@constant";
import { generateFileName } from "@utilscommon";

export const GENERAL_RSVP_SESSIONS = "GENERAL_RSVP_SESSIONS";
export const CHECKOUT_FORM_DATA = "CHECKOUT_FORM_DATA";
export const FORM_LIST = "FORM_LIST";
export const ALL_HAS_CONDITIONAL_FIELDS = "ALL_HAS_CONDITIONAL_FIELDS";
export const SECTIONWISE_FORM_LIST = "SECTIONWISE_FORM_LIST";
export const PROTECTED_PAGE = "PROTECTED_PAGE";
export const PROGRESS_DATA = "PROGRESS_DATA";
export const LAST_FIELD_UPDATED = "LAST_FIELD_UPDATED";

export const fetchCheckoutForm = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/userregistration`;
  let body = { ...data, type: "getform" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          let resCheckoutData = {};
          if (response.code === "protected") {
            resCheckoutData = response?.resource ?? {};
            let object = { isprotected: true, allowregistration: false };
            dispatch(updatedProtected(object));
          } else {
            resCheckoutData = response?.resource?.formdata ?? {};
            let resRSVPSession = response?.resource?.rsvpsessions ?? [];
            let object = { isprotected: false, allowregistration: true };
            dispatch(
              categorizeForms({ ...response?.resource, formtype: "checkout" })
            );
            dispatch(updatedProtected(object));
            dispatch({
              type: GENERAL_RSVP_SESSIONS,
              payload: { data: resRSVPSession },
            });
          }
          dispatch({
            type: CHECKOUT_FORM_DATA,
            payload: { data: resCheckoutData },
          });
          callback({ success: 1, data: resCheckoutData });
        } else {
          dispatch({ type: CHECKOUT_FORM_DATA, payload: { data: {} } });
          dispatch({ type: GENERAL_RSVP_SESSIONS, payload: { data: [] } });
          callback({ success: 2, errors: response });
        }
      },
      (error) => {
        dispatch({ type: CHECKOUT_FORM_DATA, payload: { data: {} } });
        dispatch({ type: GENERAL_RSVP_SESSIONS, payload: { data: [] } });
        callback({ success: 0, errors: error });
      }
    );
  };
};

export function verifyPasscode(session, data, callback) {
  let url = `${INSTANCE_URL}/api/v2/userregistration`;
  let body = { ...data, type: "verifypasscode" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          let resCheckoutData = response?.resource?.formdata ?? {};
          let resRSVPSession = response?.resource?.rsvpsessions ?? [];
          let object = { isprotected: true, allowregistration: true };
          dispatch({
            type: CHECKOUT_FORM_DATA,
            payload: { data: resCheckoutData },
          });
          dispatch({
            type: GENERAL_RSVP_SESSIONS,
            payload: { data: resRSVPSession },
          });
          dispatch(updatedProtected(object));
          dispatch(
            categorizeForms({ ...response?.resource, formtype: "checkout" })
          );
          callback({ success: 1, data: response });
        } else {
          callback({ success: 2, errors: response });
        }
      },
      (error) => {
        callback({ success: 0, errors: error });
      }
    );
  };
}

export const categorizeForms = (data) => {
  // console.log("data :- ", data);
  let formdata = data?.formdata;
  let rsvpsessions = data?.rsvpsessions;
  let formJson = formdata?.formjson ?? "{}";
  let formArray = JSON.parse(formJson);
  let companyinfo =
    data.formtype == "checkout"
      ? JSON.parse(formdata?.commonsetting ?? "{}")?.createcompany
      : null;

  // Append custom code to body
  if (formdata?.customcode && formdata?.customcode !== "") {
    let body = document.querySelector("body");
    let innerScript = document
      .createRange()
      .createContextualFragment(formdata?.customcode);
    body.appendChild(innerScript);
  }

  // Get all has conditional fields
  let allConditionalFields = _.filter(
    formArray,
    (obj) =>
      (obj.key === "radiobuttons" ||
        obj.key === "checkboxes" ||
        obj.key === "dropdown") &&
      obj.hasCondition
  );

  // Create section wise fields
  let fieldsArr = JSON.parse(JSON.stringify(formArray));
  let steps = [{ name: "profiledetails", status: "current", ishidden: 0 }];
  let sectionWiseArr = [];
  let currentSection = "";
  _.map(fieldsArr, (o) => {
    let key = o.key;

    if (key === "section") {
      currentSection = o?.name;
      o.elements = [];
      sectionWiseArr.push(o);

      // Check this this section is hidden or not bydefault
      let hidden = defaultSectionShowHide(currentSection, allConditionalFields);

      steps.push({ name: currentSection, status: "", ishidden: hidden });
    } else {
      let index = _.findIndex(sectionWiseArr, (e) => {
        return e?.name === currentSection;
      });

      if (index >= 0) {
        sectionWiseArr[index].elements.push(o);
      }
    }
  });

  // Add company information step at 2nd last position if any company details available
  if (companyinfo) {
    steps.push({ name: "companyinfo", status: "", ishidden: 0 });
  }
  // Add rsvp step at last position if any rsvp session available
  if (rsvpsessions?.length > 0) {
    steps.push({ name: "sessionrsvp", status: "", ishidden: 0 });
  }

  // Check default hidden fields
  let hiddenFields = [];
  _.map(formArray, (field) => {
    let fieldKey = field?.key;
    let name = field?.name;
    if (
      fieldKey === "radiobuttons" ||
      fieldKey === "checkboxes" ||
      fieldKey === "dropdown"
    ) {
      if (field?.hasCondition) {
        let hidden = [];
        _.map(field?.options, (opt) => {
          if (opt?.displayfields) {
            let split = opt?.displayfields?.split(",");
            hidden = _.concat(hidden, split);
          }
        });

        hiddenFields.push({ name: name, conditional: _.uniq(hidden) });
      }
    }
  });

  return (dispatch) => {
    dispatch({ type: FORM_LIST, payload: formArray });
    dispatch(formConditionalFields(allConditionalFields));
    dispatch(sectionWiseFormData(sectionWiseArr));
    dispatch(updatedProgress(steps));
  };
};

export const defaultSectionShowHide = (name, allConditionalFields) => {
  let ishidden = 0;

  for (let index = 0; index < allConditionalFields.length; index++) {
    let item = allConditionalFields[index];
    let options = item.options;
    let check = _.findIndex(options, (val) => {
      return val?.displayfields.indexOf(name) > -1;
    });
    // console.log("check---------- :- ", name, item);

    if (check >= 0) {
      ishidden = 1;
      break;
    }
  }

  return ishidden;
};

export const updatedProtected = (obj) => {
  return (dispatch) => {
    dispatch({ type: PROTECTED_PAGE, payload: obj });
  };
};

export const formConditionalFields = (array) => {
  // console.log("array called...................... :-", array);
  return (dispatch) => {
    dispatch({ type: ALL_HAS_CONDITIONAL_FIELDS, payload: array });
  };
};

export const sectionWiseFormData = (array) => {
  // console.log("array called...................... :-", array);
  return (dispatch) => {
    dispatch({ type: SECTIONWISE_FORM_LIST, payload: array });
  };
};

export const updatedProgress = (array) => {
  // console.log("array called...................... :-", array);
  return (dispatch) => {
    dispatch({ type: PROGRESS_DATA, payload: array });
  };
};

export const lastFieldChanged = (name) => {
  return (dispatch) => {
    dispatch({ type: LAST_FIELD_UPDATED, payload: name });
  };
};

export function checkEmail(session, data, callback) {
  let url = `${INSTANCE_URL}/api/v2/userregistration`;
  let body = { ...data, type: "validateemail" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openRegistration(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/userregistration`;

  let eventid = values.eventid;
  let profileImg = values?.profileurl ?? "";
  let speakerImg = values?.speakerurl ?? "";
  let checkoutData = JSON.parse(values?.responses);
  let otherFilesData = _.filter(checkoutData, (form) => {
    return form?.key === "file" && form?.value?.length > 0;
  });

  return (dispatch) => {
    // Step 1: Upload profile image
    _uploadProfile(session, eventid, profileImg, dispatch, false, (profile) => {
      if (profile.success) {
        values = {
          ...values,
          ...(profile.data && profile.data.path
            ? { profileurl: profile.data.path }
            : {}),
        };

        // Step 2: Upload speaker image
        _uploadProfile(
          session,
          eventid,
          speakerImg,
          dispatch,
          true,
          (speaker) => {
            if (speaker.success) {
              console.log({ speaker, values });
              values = {
                ...values,
                ...(speaker.data && speaker.data.path
                  ? { speakerurl: speaker.data.path }
                  : {}),
              };

              // Step 3: Upload additional files
              _uploadDynamicFormsFiles(
                session,
                eventid,
                otherFilesData,
                dispatch,
                (filesArray) => {
                  _.map(checkoutData, (obj) => {
                    let check = _.filter(
                      filesArray,
                      (file) => file.name === obj.name
                    );
                    if (check?.length > 0) {
                      obj.value = check[0].value;
                    }
                  });

                  values = {
                    ...values,
                    responses: JSON.stringify(checkoutData),
                  };
                  let body = { ...values, type: "register" };

                  postRequest(
                    url,
                    body,
                    session,
                    dispatch,
                    (response) => {
                      if (response.success) {
                        callback({ success: 1, data: response });
                      } else {
                        callback({ success: 2, errors: response });
                      }
                    },
                    (error) => {
                      callback({ success: 0, errors: error });
                    }
                  );
                }
              );
            } else {
              callback({ success: 4 }); // Speaker image upload failed
            }
          }
        );
      } else {
        callback({ success: 3 }); // Profile image upload failed
      }
    });
  };
}

export function _uploadProfile(
  session,
  eventid,
  imagedata,
  dispatch,
  usedforspeaker = false,
  callback
) {
  // console.log("imagedata :- ", imagedata);
  if (imagedata.search(";base64,") > 0) {
    let filepath = usedforspeaker
      ? `eventify/${eventid}/images/speakers`
      : `eventify/${eventid}/images/appusers`;
    let split = imagedata.split(";base64,");
    let content = split[1];
    let contentType = split[0];
    let ext = contentType.split("/")[1];
    if (ext !== "jpeg" && ext !== "jpg" && ext !== "png" && ext !== "svg") {
      ext = "jpg";
    }
    let filename = `${generate(32)}.${ext}`;

    var imageJson = {
      resource: [
        {
          name: `${filepath}/${filename}`,
          type: "file",
          is_base64: true,
          content: content,
        },
      ],
    };

    // Upload file
    uploadEncodedFile(
      `${BASE_IMAGES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, errors: error });
      }
    );
  } else {
    callback({ success: 1 });
  }
}

export function _uploadDynamicFormsFiles(
  session,
  eventid,
  otherFilesData,
  dispatch,
  callback
) {
  let filepath = `eventify/${eventid}/files/appuser`;

  // uploadFiles
  let promiseArray = [];
  _.map(otherFilesData, (field, key) => {
    // Files base64 value
    let savedValues = field.value;
    let uploadFiles = [];
    _.map(savedValues, (item, index) => {
      if (item) {
        promiseArray.push(
          new Promise((resolve, reject) => {
            let file = item?.file;
            let name = item?.filename;
            if (file.search(";base64,") > 0) {
              let split = file.split(";base64,");
              var content = split[1];
              var filename = `${filepath}/${generateFileName(name)}`;

              var fileJson = {
                resource: [
                  {
                    name: filename,
                    type: "file",
                    is_base64: true,
                    content: content,
                  },
                ],
              };

              uploadEncodedFile(
                `${BASE_IMAGES_URL}?check_exist=false`,
                session,
                fileJson,
                dispatch,
                (data) => {
                  uploadFiles.push(data.name);
                  resolve();
                },
                (error) => {
                  resolve();
                }
              );
            } else {
              uploadFiles.push(file);
              resolve();
            }
          })
        );
      }
    });

    field.value = uploadFiles;
  });

  Promise.all(promiseArray).then(() => {
    // console.log("otherFilesData uploaded :- ", otherFilesData);
    callback(otherFilesData);
  });
}

export function _uploadSocialBanner(session, imagedata, callback) {
  let filepath = `eventify/${session.eventid}/images/others`;
  let split = imagedata.split(";base64,");
  let content = split[1];
  let contentType = split[0];
  let ext = contentType.split("/")[1];
  if (ext !== "jpeg" && ext !== "jpg" && ext !== "png" && ext !== "svg") {
    ext = "jpg";
  }
  let filename = `${generate(32)}.${ext}`;

  var imageJson = {
    resource: [
      {
        name: `${filepath}/${filename}`,
        type: "file",
        is_base64: true,
        content: content,
      },
    ],
  };

  return (dispatch) => {
    uploadEncodedFile(
      `${BASE_IMAGES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, errors: error });
      }
    );
  };
}
